<template>
  <div class="tw-overflow-x-auto">
    <table class="bk-table bk-table--compact">
      <thead>
        <tr>
          <th>Source name</th>
          <th>Sync cron schedule</th>
          <th>Sync next run</th>
          <th>Purge cron schedule</th>
          <th>Purge next run</th>
          <th>Reconcile cron schedule</th>
          <th>Reconcile next run</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cronSchedule of cronSchedules" :key="cronSchedule.sourceName">
          <td class="tw-font-semibold">{{ cronSchedule.sourceName }}</td>
          <td>
            <CronStrings v-if="cronSchedule.sync" :cron-strings="cronSchedule.sync.cronStrings" :enabled="cronSchedule.sync.enabled" />
            <span v-else class="tw-text-muted">N/A</span>
          </td>
          <td>
            <DisplayDatetimeCron
              v-if="cronSchedule.sync"
              :cron-schedule="cronSchedule.sync"
              :class="{ 'tw-text-muted': !cronSchedule.sync.enabled }"
            />
            <span v-else class="tw-text-muted">N/A</span>
          </td>
          <td>
            <CronStrings v-if="cronSchedule.purge" :cron-strings="cronSchedule.purge.cronStrings" :enabled="cronSchedule.purge.enabled" />
            <span v-else class="tw-text-muted">N/A</span>
          </td>
          <td>
            <DisplayDatetimeCron
              v-if="cronSchedule.purge"
              :cron-schedule="cronSchedule.purge"
              :class="{ 'tw-text-muted': !cronSchedule.purge.enabled }"
            />
            <span v-else class="tw-text-muted">N/A</span>
          </td>
          <td>
            <CronStrings v-if="cronSchedule.reconcile" :cron-strings="cronSchedule.reconcile.cronStrings" :enabled="cronSchedule.reconcile.enabled" />
            <span v-else class="tw-text-muted">N/A</span>
          </td>
          <td>
            <DisplayDatetimeCron
              v-if="cronSchedule.reconcile"
              :cron-schedule="cronSchedule.reconcile"
              :class="{ 'tw-text-muted': !cronSchedule.reconcile.enabled }"
            />
            <span v-else class="tw-text-muted">N/A</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DisplayDatetimeCron from './DisplayDatetimeCron'
import CronStrings from './CronStrings'

export default {
  props: {
    cronSchedules: Array,
  },
  components: {
    DisplayDatetimeCron,
    CronStrings,
  },
}
</script>
